<script setup lang="ts">
//#region imports
import { inject } from 'vue';
//#endregion

//#region types
type TreeType = 'outer' | undefined;
type TreeThickness = 'thin' | 'medium';
//#endregion

//#region composables
const type = inject<TreeType>('type', undefined);
const thickness = inject<TreeThickness>('thickness', 'medium');
//#endregion
</script>

<template>
  <div
    :class="{
      'tree-branch': true,
      'tree-branch_outer': type === 'outer',
      'tree-branch_thickness-thin': thickness === 'thin',
      'tree-branch_thickness-medium': thickness === 'medium',
    }"
  >
    <slot />
  </div>
</template>

<style lang="scss">
.tree-branch {
  padding-left: 16px;
  position: relative;

  &_thickness-thin {
    &::before {
      border-left: 1px solid var(--border-default);
    }

    &::after {
      border-top: 1px solid var(--border-default);
    }
  }

  &_thickness-medium {
    &::before {
      border-left: 1px solid var(--border-default);
    }

    &::after {
      border-top: 1px solid var(--border-default);
    }
  }

  &::before {
    content: '';
    display: block;
    position: absolute;
    left: 8px;
    top: 0;
    height: 100%;
  }

  &:last-of-type {
    &::before{
      height: 50%;
    }
  }

  &:only-of-type {
    &::before,
    &::after {
      content: none;
    }
  }

  &::after {
    content: '';
    display: block;
    position: absolute;
    left: 8px;
    top: 50%;
    width: 8px;
  }

  &_outer {
    padding-left: 8px;
    &::before {
      left: 0;
    }
    &:only-child {
      padding-left: 0;
    }

    &:first-child {
      &::before {
        height: 50%;
        top: 50%;
      }
    }

    &::after {
      left: 0;
    }
  }
}
</style>
